import "./BootcampText.css"

const BootcampText = () => {
	return (
		<div className="bootcampText" data-testid='bootcampText-div'>
			<p className="bootcampText__line1"> In February 2022, I graduated from <span className="bootcampText__academy">Makers Academy</span> in London.</p>
			<p className="bootcampText__line2">Emerging relatively unscathed, I managed to master the fundamentals of <span className="bootcampText__academy">software and web development. </span></p>

		</div>
	)
}

export default BootcampText